import { clamp } from "@perceptron/utils/math";

/** How far above the scrub-bar row a time chip floats, into the ruler. */
export const TIME_CHIP_OFFSET_Y = 22;

// Chips use tabular numerals, so their width follows the text length alone.
// Measuring only when that changes avoids a forced layout on every frame.
const measuredWidths = new WeakMap<HTMLElement, { length: number; width: number }>();

/**
 * Write `text` into a chip anchored at `x` (canvas-column px) and keep it
 * centred on `x`, but inside the column at either end.
 */
export function placeTimeChip(chip: HTMLElement, text: string, x: number, viewportWidth: number): void {
  if (chip.textContent !== text) chip.textContent = text;
  let measured = measuredWidths.get(chip);
  if (measured?.length !== text.length) {
    measured = { length: text.length, width: chip.offsetWidth };
    measuredWidths.set(chip, measured);
  }
  const { width } = measured;
  const offset = clamp(-width / 2, -x, Math.max(-x, viewportWidth - x - width));
  chip.style.transform = `translateX(${Math.round(offset)}px)`;
}
